import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Navbar from "../NavBar";
import CustomNavbar from "../CustomPermissions/CustomNavbar";
import { Link } from "react-router-dom";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const PartnerProgramTable = () => {
  const [files, setFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [datalength, setLengthOfRecords] = useState(0);
  const [filters, setFilters] = useState({
    filetype: "",
    company: "",
    name: "",
    desc: "",
    for_date: "",
    valid_date: "",
    rate: "",
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    filetype: null,
    company: null,
    name: "",
    desc: "",
    docs: null,
    for_date: "",
    valid_date: "",
    rate: "",
  });
  const [editFileId, setEditFileId] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleAccordion = (index) => {
    setExpandedRow((prev) => (prev === index ? null : index));
  };
  useEffect(() => {
    fetchAllFiles();
    fetchFileTypes();
    fetchCompanies();
  }, []);

  // Apply filters whenever `filters` or `files` changes
  useEffect(() => {
    applyFilters();
  }, [filters, files]);

  const fetchAllFiles = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/PartnerFiles/partners-files/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setLengthOfRecords(response.data.length);
      // Sort files by file name by default
      const sortedFiles = response.data.sort((a, b) => {
        const nameA = a.name?.toLowerCase() || "";
        const nameB = b.name?.toLowerCase() || "";

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        // If file names are the same, sort by company name
        const companyA = a.company__name?.toLowerCase() || "";
        const companyB = b.company__name?.toLowerCase() || "";

        if (companyA < companyB) return -1;
        if (companyA > companyB) return 1;

        return 0;
      });

      setFiles(sortedFiles);
      setFilteredFiles(sortedFiles);
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

  const fetchFileTypes = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/PartnerFiles/filetypes/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include token if required
          },
        }
      );
      setFileTypes(response.data);
    } catch (error) {
      console.error("Error fetching file types:", error);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/PartnerFiles/companies/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Replace with your token retrieval logic
          },
        }
      );
      setCompanies(response.data.data);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleDeleteFile = async (id) => {
    try {
      await axios.delete(
        getApiUrl(`/PartnerFiles/partners-files/${id}/`),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      fetchAllFiles();
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const applyFilters = () => {
    const filtered = files.filter((file) => {
      // Ensure for_date is a valid date
      const forDate =
        file.for_date && Date.parse(file.for_date)
          ? new Date(file.for_date)
          : null;
      const fileMonth = forDate ? forDate.getMonth() + 1 : null;
      const fileYear = forDate ? forDate.getFullYear() : null;

      return (
        (!filters.filetype || file.filetype === parseInt(filters.filetype)) &&
        (!filters.company || file.company === parseInt(filters.company)) &&
        (!filters.name ||
          file.name.toLowerCase().includes(filters.name.toLowerCase())) &&
        (!filters.desc ||
          file.desc?.toLowerCase().includes(filters.desc.toLowerCase())) &&
        (!filters.for_date || file.for_date === filters.for_date) &&
        (!filters.valid_date || file.valid_date === filters.valid_date) &&
        (!filters.rate || file.rate.includes(filters.rate)) &&
        (!filters.month || fileMonth === parseInt(filters.month)) &&
        (!filters.year || fileYear === parseInt(filters.year))
      );
    });
    setFilteredFiles(filtered);
  };

  const resetFilters = () => {
    setFilters({
      filetype: "",
      company: "",
      name: "",
      desc: "",
      for_date: "",
      valid_date: "",
      rate: "",
      month: "",
      year: "",
    });
    setFilteredFiles(files);
  };

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "docs") {
      setFileDetails((prev) => ({ ...prev, docs: files[0] }));
    } else {
      setFileDetails((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(fileDetails).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });

    const url = editFileId
      ? getApiUrl(`/PartnerFiles/partners-files/${editFileId}/`)
      : getApiUrl("/PartnerFiles/partners-files/");
    const method = editFileId ? "put" : "post";

    try {
      await axios({
        method,
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      fetchAllFiles();
      setModalOpen(false);
      resetForm();
      toast.success(editFileId ? "File updated successfully" : "File uploaded successfully");
    } catch (error) {
      console.error("Error saving file:", error);
      if (!error.response) {
        toast.error("Network error: " + error.message);
        return;
      }
      const data = error.response.data;
      if (!data) {
        toast.error(`Error ${error.response.status}: ${error.response.statusText}`);
        return;
      }
      if (typeof data === 'string') {
        toast.error(data.length > 100 ? "Server error occurred" : data);
      } else if (typeof data === 'object') {
        if (data.detail) {
          toast.error(data.detail);
        } else if (data.error) {
          toast.error(data.error);
        } else {
          Object.keys(data).forEach((field) => {
            const message = data[field];
            if (Array.isArray(message)) {
              message.forEach((msg) => toast.error(`${field}: ${msg}`));
            } else if (typeof message === 'string') {
              toast.error(`${field}: ${message}`);
            } else {
              toast.error(`${field}: Invalid value`);
            }
          });
        }
      } else {
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const resetForm = () => {
    setFileDetails({
      filetype: "",
      company: "",
      name: "",
      desc: "",
      docs: null,
      for_date: "",
      valid_date: "",
      rate: "",
    });
    setEditFileId(null);
  };

  const handleEdit = (file) => {
    setFileDetails({
      filetype: file.filetype ? String(file.filetype) : "",
      company: file.company ? String(file.company) : "",
      name: file.name,
      desc: file.desc || "",
      docs: null,
      for_date: file.for_date,
      valid_date: file.valid_date,
      rate: file.rate,
    });
    setEditFileId(file.id);
    setModalOpen(true);
  };

  const onClose = () => {
    setModalOpen(false);
    resetForm();
  };

  return (
    <div className="font-sans flex">
      {/* <Navbar /> */}
      <CustomNavbar />
      <div
        className="container-fluid mt-2"
        style={{ width: "90vw", margin: "auto" }}
      >
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mt-2"
        >
          <h1 className="text-3xl text-blue-500 mb-4">
            Legal Files Agreements
          </h1>

          <div>
            <Link
              to="/fileType"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-800"
              // state={{ userPermissions: "teamleader and docladdermember" }}
              style={{ color: "black", marginRight: "20px" }}
            >
              Add File-Type
            </Link>

            <button
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-900 ml-2 mt-2"
              onClick={() => setModalOpen(true)}
            >
              Add Legal File
            </button>
          </div>
        </div>

        {/* Filters */}
        <div className="mb-4 mt-3 grid grid-cols-3 gap-2">
          <select
            name="filetype"
            style={{ fontSize: "13px" }}
            value={filters.filetype}
            onChange={handleFilterChange}
            className="border p-2 rounded"
          >
            <option value="">All File Types</option>
            {fileTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>

          <select
            name="company"
            value={filters.company}
            style={{ fontSize: "13px" }}
            onChange={handleFilterChange}
            className="border p-2 rounded"
          >
            <option value="">All Companies</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </select>

          <input
            type="text"
            name="name"
            value={filters.name}
            style={{ fontSize: "13px" }}
            onChange={handleFilterChange}
            placeholder="Search by Name"
            className="border p-2 rounded"
          />

          <input
            type="text"
            name="desc"
            value={filters.desc}
            style={{ fontSize: "13px" }}
            onChange={handleFilterChange}
            placeholder="Search by Description"
            className="border p-2 rounded"
          />

          <input
            type="number"
            name="year"
            value={filters.year}
            style={{ fontSize: "13px" }}
            onChange={handleFilterChange}
            placeholder="Search by Year"
            className="border p-2 rounded"
          />
        </div>

        {/* Table */}
        <table className="w-100 bg-white mt-3 mb-5 border-separate border-spacing-2 border border-gray-400 dark:border-gray-500">
          <thead className="bg-[#012E47] text-white rounded">
            <tr>
              <th colSpan="8" className="bg-white text-dark">
                Current Deals: {datalength}
              </th>
            </tr>
            <tr className="bg-blue-500 rounded">
              <th className="py-2 px-1 text-center border border-gray-300 dark:border-gray-600">Sr. No</th>
              <th className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">Name</th>
              <th className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">File Type</th>
              <th className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">For Date</th>
              <th className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">Valid Date</th>
              <th className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">Rate</th>
              <th className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">Description</th>
            </tr>
          </thead>
          <tbody>
            {filteredFiles.map((file, index) => (
              <React.Fragment key={file.id}>
                {/* Main Row */}
                <tr
                  className="hover:bg-gray-50 cursor-pointer"
                  style={{ fontSize: "14px" }}
                  onClick={(e) => {
                    if (!e.target.closest("td:last-child")) {
                      toggleAccordion(index);
                    }
                  }}
                >
                  <td className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">{index + 1}</td>
                  <td className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">
                    {file.name}
                    <br />
                    <span className="text-gray-500 text-sm">
                      Company: {file.company__name || "N/A"}
                    </span>
                  </td>
                  <td className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">
                    {file.filetype__name}
                  </td>
                  <td className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">{file.for_date}</td>
                  <td className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">{file.valid_date}</td>
                  <td className="py-2 px-2 text-center border border-gray-300 dark:border-gray-600">{file.rate}</td>

                  <td className="py-4 px-2 text-center flex space-x-2 justify-center border border-gray-300 dark:border-gray-600">
                    {file.docs ? (
                      <a
                        href={getApiUrl(`/media/${file.docs}/`)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-800"
                        title="View File"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-eye"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                      </a>
                    ) : (
                      <>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye-slash-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                          </svg>
                        </span>
                      </>
                    )}
                    {/* Edit Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(file);
                      }}
                      className="text-amber-600 hover:text-yellow-800 px-2"
                      title="Edit File"
                      style={{ color: "#FBBF24" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-pen-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001" />
                      </svg>
                    </button>
                    {/* Delete Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          window.confirm(
                            "Are you sure you want to delete this file? This action cannot be undone."
                          )
                        )
                          handleDeleteFile(file.id);
                      }}
                      className="text-red-600 hover:text-red-800"
                      title="Delete File"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                      </svg>
                    </button>
                  </td>
                </tr>
                {expandedRow === index && (
                  <tr>
                    <td colSpan="8" className="p-4 bg-gray-50">
                      <strong>Description:</strong> {file.desc || "N/A"}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {modalOpen && (
        <div
          className="fixed inset-0 flex justify-center items-center z-50"
          id="marketingmodalopen"
          style={{ width: "100vw", height: "100vh" }}
        >
          {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"></div> */}
          <div
            className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
            style={{
              width: "100vw",
              height: "150%",
              background: "black",
              backgroundSize: "200% 200vh",
              overflowY: "hidden",
              paddingBottom: "150px",
            }}
          ></div>
          {/* <div className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg" style={{ marginTop: "100px" }}> */}
          <div
            className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg"
            style={{
              // marginTop: "50px",
              height: "95vh", // Set height to allow scrolling
              overflowY: "auto", // Enable scrolling inside modal
            }}
          >
            <div
              className="overflow-auto max-h-[80vh]"
              style={{ padding: "100px", paddingTop: "20px" }}
            >
              <h2 className="text-center text-blue-700 mb-2">Add Legal File</h2>

              <form onSubmit={handleSubmit} className="p-4 space-y-6">
                {/* Grid Layout */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {/* File Type */}
                  <div>
                    <label
                      htmlFor="filetype"
                      className="block text-sm font-medium text-gray-700"
                    >
                      File Type
                    </label>
                    <select
                      id="filetype"
                      name="filetype"
                      value={fileDetails.filetype}
                      onChange={handleFormChange}
                      style={{ fontSize: "14px" }}
                      required
                      className="w-full mt-1 p-2 border rounded"
                    >
                      <option value="">Select Type</option>
                      {fileTypes.map((type) => (
                        <option key={type.id} value={String(type.id)}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Company */}
                  <div>
                    <label
                      htmlFor="company"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Company
                    </label>
                    <select
                      id="company"
                      name="company"
                      value={fileDetails.company}
                      onChange={handleFormChange}
                      // required
                      style={{ fontSize: "14px" }}
                      className="w-full mt-1 p-2 border rounded"
                    >
                      <option value="">Select Company</option>
                      {companies.map((company) => (
                        <option key={company.id} value={String(company.id)}>
                          {company.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Name */}
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      File Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      name="name"
                      value={fileDetails.name}
                      onChange={handleFormChange}
                      style={{ fontSize: "14px" }}
                      required
                      className="w-full mt-1 p-2 border rounded"
                    />
                  </div>

                  {/* Description */}


                  {/* For Date */}
                  <div>
                    <label
                      htmlFor="for_date"
                      className="block text-sm font-medium text-gray-700"
                    >
                      For Date
                    </label>
                    <input
                      id="for_date"
                      type="date"
                      name="for_date"
                      value={fileDetails.for_date}
                      onChange={handleFormChange}
                      style={{ fontSize: "14px" }}
                      className="w-full mt-1 p-2 border rounded"
                    />
                  </div>

                  {/* Valid Date */}
                  <div>
                    <label
                      htmlFor="valid_date"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Valid Date
                    </label>
                    <input
                      id="valid_date"
                      type="date"
                      name="valid_date"
                      value={fileDetails.valid_date}
                      style={{ fontSize: "14px" }}
                      onChange={handleFormChange}
                      className="w-full mt-1 p-2 border rounded"
                    />
                  </div>

                  {/* Rate */}
                  <div>
                    <label
                      htmlFor="rate"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Rate
                    </label>
                    <input
                      id="rate"
                      type="text"
                      name="rate"
                      value={fileDetails.rate}
                      onChange={handleFormChange}
                      // required
                      style={{ fontSize: "14px" }}
                      className="w-full mt-1 p-2 border rounded"
                    />
                  </div>

                  {/* Document */}
                  <div>
                    <label
                      htmlFor="docs"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Upload Document
                    </label>
                    <input
                      id="docs"
                      type="file"
                      name="docs"
                      style={{ fontSize: "14px" }}
                      onChange={handleFormChange}
                      className="w-full mt-1 p-2 border rounded"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="desc"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Description
                  </label>
                  <textarea
                    id="desc"
                    name="desc"
                    value={fileDetails.desc}
                    onChange={handleFormChange}
                    style={{ fontSize: "14px", height: "250px", width: "100%", zIndex: "4" }}
                    className="w-full mt-1 p-2 border rounded"
                  />
                </div>

                {/* Buttons */}
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-800 rounded"
                  >
                    {editFileId ? "Update" : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default PartnerProgramTable;
